import { render, staticRenderFns } from "./SourceViewer.vue?vue&type=template&id=1603887a"
import script from "./SourceViewer.vue?vue&type=script&lang=js"
export * from "./SourceViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports